import React from 'react'

const CounterResults = ({ filter, total }) => {
    return (
        <div className='text-muted'>Resultados: {filter}/{total}</div>
    )
}

export default CounterResults;